export const environment = {
  backendDomain: 'https://api.thrivecatalog.dev',
  typesenseProductDBApiKey: 'l9eTGRo8zQCCTEyy2xXayynhMKx3g0PH',
  typesenseProductDBDomain: 'search.thrivecatalog.dev',
  /**
   * Technical support: https://mui.com/r/x-technical-support
   * Your support key (same as your order ID): 107687
   * @note MUI license key does not need to be a secret
   * @see http://mui.com/components/data-grid/getting-started/#security
   */
  muiLicenseKey:
    'f7c5aaa84af9af0a9f156a4736118534Tz0xMTAzMzgsRT0xNzcwODU0Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
};
